import { ModelMapper } from "@omni/types/utils/modelMapper";

import { applyHighlight } from "@/utils/textUtils";

import {
    HIGHLIGHT_POSTFIX,
    HIGHLIGHT_PREFIX
} from "../storeSearchInput.config";
import { SearchItem, SearchItemType } from "../storeSearchInput.types";

export const addressMapper: ModelMapper<
    woosmap.map.localities.LocalitiesPredictions,
    SearchItem
> = (address) => ({
    value: address.public_id,
    label: address.description,
    highlightedLabel: applyHighlight(
        HIGHLIGHT_PREFIX,
        HIGHLIGHT_POSTFIX,
        address.description,
        address.matched_substrings?.description
    ),
    type: SearchItemType.Locality
});
